import React from "react";
import { useSelector } from "react-redux";
import GlobalDeleteDialog from "../../../components/mui/Dialogue/GlobalDeleteDialog";
import {
  deleteBrand,
  getAllBrands,
} from "../../../redux/features/assetManagementSlice";

const DeleteBrand = ({ id, data }) => {
  const { loading } = useSelector((state) => state.assetmanagement);
  const { paginationData, openAnchor } = useSelector(
    (state) => state.globalDataGrid
  );

  return (
    <GlobalDeleteDialog
      title={"Delete Brand"}
      deleteNote={"Are you sure? you want to delete this Brand..?"}
      api={deleteBrand(id)}
      upDateCall={getAllBrands(data)}
      loading={loading}
    />
  );
};

export default DeleteBrand;
